import React, { useState } from 'react';
import classnames from 'classnames';

import useKeyboardEvent from 'hooks/useKeyboardEvent.js';

const RedeemGiftModal = ({ onToggleClose, isOpen, donationLandingStore }) => {
  const [giftCode, setGiftCode] = useState('');

  useKeyboardEvent('Escape', () => {
    onToggleClose(false);
  });

  const handleInputChange = (e) => {
    const value = e.target.value;
    setGiftCode(value);
  };

  const handleRedeem = async () => {
    await donationLandingStore.redeemGiftToken({ token: giftCode });
    onToggleClose();
  };

  return (
    <div
      className={classnames('modal share-modal', {
        'is-active': isOpen,
      })}
    >
      <div className="modal-background" onClick={() => onToggleClose(false)} />
      <div className="modal-card">
        <section className="modal-card-body">
          <div className="share-link-x-container flex-row flex-justify-end">
            <button
              className="delete"
              aria-label="close"
              onClick={onToggleClose}
            />
          </div>
          <div>
            <div className="share-link-title">Redeem Gift</div>
          </div>
          <div className="share-link-container">
            <input
              className="share-link text-center"
              placeholder="XXXXXX"
              value={giftCode}
              onChange={handleInputChange}
              maxLength={6}
            />
          </div>
          <div>
            <div className="flex gap-x-2 justify-between pt-4">
              <button
                className="cz-btn-brand flex-1"
                onClick={(e) => {
                  e.preventDefault();
                  handleRedeem();
                }}
              >
                Redeem
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default RedeemGiftModal;
